"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validProgress = validProgress;

// eslint-disable-next-line import/prefer-default-export
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/progress/utils.js
// module id = 271
// module chunks = 0